import { render, staticRenderFns } from "./ClientFinancial.vue?vue&type=template&id=49a9ddad"
import script from "./ClientFinancial.vue?vue&type=script&lang=js"
export * from "./ClientFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports